import React, { FunctionComponent } from 'react';

import { StyledLink } from './link.styled';
import { LinkProps, LinkTheme } from './types';

export const Link: FunctionComponent<LinkProps> = (props) => {
    const { $focusTheme = LinkTheme.LIGHT, target = '_blank', rel = 'noopener', ...rest } = props;

    return <StyledLink {...rest} $focusTheme={$focusTheme} rel={rel} target={target} component="a" />;
};
